
import { computed, defineComponent, PropType } from 'vue';
import { ImageFileModel } from '@/types/B2BcontentServerContract';

export default defineComponent({
    name: 'HeroBannerSimple',
    props: {
        title: {
            required: false,
            type: String,
            default: '',
        },
        image: {
            required: false,
            type: Object as PropType<ImageFileModel>,
            default: () => {},
        },
        scrim: {
            required: false,
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const focusPoints = computed(() => {
            return props.image.focus ? props.image.focusPoints : '';
        });

        return {
            focusPoints,
        };
    },
});
